export type AppConfigRegistryEntry = {
  name: string;
  version: string;
};

export const MANIFEST_UPDATE_CONFIG_NAME = "manifest-update";

/**
 * PRS configs fetched once per app session on initialization.
 * Add new entries here to load additional config documents into Redux.
 */
export const APP_CONFIG_REGISTRY: AppConfigRegistryEntry[] = [
  {
    name: MANIFEST_UPDATE_CONFIG_NAME,
    version: "2"
  }
];
